export interface CsvColumn<T> {
  header: string;
  value: (row: T) => string | number | boolean | null | undefined;
}

// Cells starting with these characters can be run as formulas when the file is
// opened in Excel, so they're prefixed with a quote (as the DataGrid export does).
const FORMULA_PREFIXES = ["=", "+", "-", "@", "\t", "\r"];

const formatCell = (value: string | number | boolean | null | undefined) => {
  if (value === null || value === undefined) return "";

  let text = String(value);
  if (typeof value === "string" && FORMULA_PREFIXES.includes(text.charAt(0))) {
    text = `'${text}`;
  }

  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const toCsv = <T>(rows: T[], columns: CsvColumn<T>[]): string =>
  [
    columns.map((column) => formatCell(column.header)).join(","),
    ...rows.map((row) =>
      columns.map((column) => formatCell(column.value(row))).join(","),
    ),
  ].join("\r\n");

// The byte order mark makes Excel open the file as UTF-8.
const BOM = String.fromCharCode(0xfeff);

export const downloadCsv = <T>(
  fileName: string,
  rows: T[],
  columns: CsvColumn<T>[],
): void => {
  const blob = new Blob([BOM + toCsv(rows, columns)], {
    type: "text/csv;charset=utf-8",
  });
  const url = globalThis.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();

  link.remove();
  globalThis.URL.revokeObjectURL(url);
};
